const boot = (email) => {
  const appId = process.env.REACT_APP_API_INTERCOM_APP_ID;
  const payload = { app_id: appId };

  if (email) {
    payload.email = email;
  }
  window.Intercom('boot', payload);
};

const update = () => {
  window.Intercom('update');
};

const reset = () => {
  window.Intercom('shutdown');
  boot();
};

export const Intercom = {
  boot,
  update,
  reset,
}
;
